import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';

// Customer API
const CUSTOMER_SEND_OTP =
  process.env.REACT_APP_CUSTOMER_SEND_OTP || process.env.REACT_APP_SEND_OTP_URL || '/customer/send-otp/';
const CUSTOMER_VERIFY =
  process.env.REACT_APP_CUSTOMER_VERIFY || process.env.REACT_APP_VERIFY_OTP_URL || '/customer/verify';
const CUSTOMER_LOGIN =
  process.env.REACT_APP_CUSTOMER_LOGIN || process.env.REACT_APP_THERAPP_LOGIN || '/customer/login';
const CUSTOMER_REGISTER =
  process.env.REACT_APP_CUSTOMER_REGISTER || process.env.REACT_APP_REGISTER_URL || '/customer/registration/create';
const CUSTOMER_DETAILS = process.env.REACT_APP_CUSTOMER_DETAILS || '/customer/';
const CUSTOMER_UPDATE = process.env.REACT_APP_CUSTOMER_UPDATE || '/customer/';
const CUSTOMER_DELETE =
  process.env.REACT_APP_CUSTOMER_DELETE || process.env.REACT_APP_DELETE_ACCOUNT || '/customer/delete-account';
const CUSTOMER_FETCH_ALL = process.env.REACT_APP_CUSTOMER_FETCH_ALL || '/customer/fetch-all';
const CUSTOMER_DATA_LAKE_LOGIN =
  process.env.REACT_APP_CUSTOMER_DATA_LAKE_LOGIN || '/customer/registration/data-lake-login/';
const CUSTOMER_ALTERNATE_LOGIN =
  process.env.REACT_APP_CUSTOMER_ALTERNATE_LOGIN || '/customer/registration/alternate-login/';
// Sessions (add after CANCEL_SESSION)
const FETCH_SESSIONS_BY_CUSTOMER = process.env.REACT_APP_FETCH_SESSIONS_BY_CUSTOMER || '';
const FETCH_SESSIONS_BY_STATUS   = process.env.REACT_APP_FETCH_SESSIONS_BY_STATUS   || '';
const FETCH_SESSIONS_BY_DATE     = process.env.REACT_APP_FETCH_SESSIONS_BY_DATE     || '';
const SESSION_REPORT             = process.env.REACT_APP_SESSION_REPORT             || '';

// Credits (add after FETCH_CREDITS)
const APPLY_CREDIT               = process.env.REACT_APP_APPLY_CREDIT               || '';
const REFUND_CREDIT              = process.env.REACT_APP_REFUND_CREDIT              || '';

// Payments (add after CHECK_PAYMENT_STATUS)
const SYNC_PAYMENT_STATUS        = process.env.REACT_APP_SYNC_PAYMENT_STATUS        || '';
const SESSION_PAYMENT            = process.env.REACT_APP_SESSION_PAYMENT            || '';
const CONVERT_CREDITS            = process.env.REACT_APP_CONVERT_CREDITS            || '';

// Therapists (add after THERAPIST_BASE)
const FETCH_MATCHING_THERAPISTS  = process.env.REACT_APP_FETCH_MATCHING_THERAPISTS  || '';
// Legacy names (used by non-customer services)
const SAVE_USER_INFO = process.env.REACT_APP_SAVE_USER_INFO || '';
const SAVE_PREFERENCE = process.env.REACT_APP_SAVE_PREFERENCE || '';
const EDIT_PREFERENCE = process.env.REACT_APP_EDIT_PREFERENCE || '';
const CHECK_PREFERENCE = process.env.REACT_APP_USER_ID_PREF || '';
const FETCH_PREFERENCES = process.env.REACT_APP_FETCH_PREFERENCES || '';
const FETCH_THERAPISTS = process.env.REACT_APP_FETCH_THERAPISTS || '';
const THERAPIST_BASE = process.env.REACT_APP_THERAPIST_BASE || '';
const SESSION_BASE = process.env.REACT_APP_SESSION_BASE || '';
const BOOK_SESSION = process.env.REACT_APP_BOOK_SESSION || '';
const FETCH_SESSIONS = process.env.REACT_APP_FETCH_SESSIONS || '';
const CANCEL_SESSION = process.env.REACT_APP_CANCEL_SESSION || '';
const CREATE_CREDIT = process.env.REACT_APP_CREATE_CREDIT || '';
const FETCH_CREDITS = process.env.REACT_APP_FETCH_CREDITS || '';
const FETCH_THERAPIST_SESSIONS = process.env.REACT_APP_FETCH_THERAPIST_SESSIONS || '';
const INITIATE_PAYMENT = process.env.REACT_APP_INITIATE_PAYMENT || '';
const FETCH_FEES = process.env.REACT_APP_FETCH_FEES || '';
const USER_PAYMENTS = process.env.REACT_APP_USER_PAYMENTS || '';
const CHECK_PAYMENT_STATUS = process.env.REACT_APP_CHECK_PAYMENT_STATUS || '';
const RATINGS_BASE = process.env.REACT_APP_RATINGS_BASE || '';
const CONFIRM_USER = process.env.REACT_APP_CONFIRM_USER || '';
const FETCH_RANDOM_THERAPISTS = process.env.REACT_APP_FETCH_RANDOM_THERAPISTS || ''
const JITSI_URL = process.env.REACT_APP_JITSI || 'https://meet.jit.si';

export const ENV = {
  BASE_URL,
  API_KEY,
  CUSTOMER_SEND_OTP,
  CUSTOMER_VERIFY,
  CUSTOMER_LOGIN,
  CUSTOMER_REGISTER,
  CUSTOMER_DETAILS,
  CUSTOMER_UPDATE,
  CUSTOMER_DELETE,
  CUSTOMER_FETCH_ALL,
  CUSTOMER_DATA_LAKE_LOGIN,
  CUSTOMER_ALTERNATE_LOGIN,
  // Legacy aliases for services
  THERAPP_LOGIN: CUSTOMER_LOGIN,
  SEND_OTP_URL: CUSTOMER_SEND_OTP,
  VERIFY_OTP_URL: CUSTOMER_VERIFY,
  REGISTER_URL: CUSTOMER_REGISTER,
  DELETE_ACCOUNT: CUSTOMER_DELETE,
  SAVE_USER_INFO,
  SAVE_PREFERENCE,
  EDIT_PREFERENCE,
  CHECK_PREFERENCE,
  FETCH_PREFERENCES,
  FETCH_THERAPISTS,
  THERAPIST_BASE,
  FETCH_RANDOM_THERAPISTS,
  SESSION_BASE,
  BOOK_SESSION,
  FETCH_SESSIONS,
  CANCEL_SESSION,
  CREATE_CREDIT,
  FETCH_CREDITS,
  FETCH_THERAPIST_SESSIONS,
  INITIATE_PAYMENT,
  FETCH_FEES,
  USER_PAYMENTS,
  CHECK_PAYMENT_STATUS,
  RATINGS_BASE,
  CONFIRM_USER,
  JITSI_URL,
  FETCH_SESSIONS_BY_CUSTOMER,
FETCH_SESSIONS_BY_STATUS,
FETCH_SESSIONS_BY_DATE,
SESSION_REPORT,
APPLY_CREDIT,
REFUND_CREDIT,
SYNC_PAYMENT_STATUS,
SESSION_PAYMENT,
CONVERT_CREDITS,
FETCH_MATCHING_THERAPISTS,
};

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: API_KEY,
  },
});

// Retry interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config || config.__retryCount >= 3) {
      return Promise.reject(error);
    }
    config.__retryCount = (config.__retryCount || 0) + 1;
    await new Promise((res) => setTimeout(res, 1000 * config.__retryCount));
    return apiClient(config);
  }
);
